/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskApiAppCoreModelsScansIRS990OtherRevenueMisc
 */
export interface ExecRiskApiAppCoreModelsScansIRS990OtherRevenueMisc {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppCoreModelsScansIRS990OtherRevenueMisc
     */
    desc?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppCoreModelsScansIRS990OtherRevenueMisc
     */
    business_cd?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskApiAppCoreModelsScansIRS990OtherRevenueMisc
     */
    total_revenue_column_amt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskApiAppCoreModelsScansIRS990OtherRevenueMisc
     */
    related_or_exempt_func_income_amt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskApiAppCoreModelsScansIRS990OtherRevenueMisc
     */
    unrelated_business_revenue_amt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskApiAppCoreModelsScansIRS990OtherRevenueMisc
     */
    exclusion_amt?: number;
}

/**
 * Check if a given object implements the ExecRiskApiAppCoreModelsScansIRS990OtherRevenueMisc interface.
 */
export function instanceOfExecRiskApiAppCoreModelsScansIRS990OtherRevenueMisc(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskApiAppCoreModelsScansIRS990OtherRevenueMiscFromJSON(json: any): ExecRiskApiAppCoreModelsScansIRS990OtherRevenueMisc {
    return ExecRiskApiAppCoreModelsScansIRS990OtherRevenueMiscFromJSONTyped(json, false);
}

export function ExecRiskApiAppCoreModelsScansIRS990OtherRevenueMiscFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskApiAppCoreModelsScansIRS990OtherRevenueMisc {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'desc': !exists(json, 'desc') ? undefined : json['desc'],
        'business_cd': !exists(json, 'business_cd') ? undefined : json['business_cd'],
        'total_revenue_column_amt': !exists(json, 'total_revenue_column_amt') ? undefined : json['total_revenue_column_amt'],
        'related_or_exempt_func_income_amt': !exists(json, 'related_or_exempt_func_income_amt') ? undefined : json['related_or_exempt_func_income_amt'],
        'unrelated_business_revenue_amt': !exists(json, 'unrelated_business_revenue_amt') ? undefined : json['unrelated_business_revenue_amt'],
        'exclusion_amt': !exists(json, 'exclusion_amt') ? undefined : json['exclusion_amt'],
    };
}

export function ExecRiskApiAppCoreModelsScansIRS990OtherRevenueMiscToJSON(value?: ExecRiskApiAppCoreModelsScansIRS990OtherRevenueMisc | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'desc': value.desc,
        'business_cd': value.business_cd,
        'total_revenue_column_amt': value.total_revenue_column_amt,
        'related_or_exempt_func_income_amt': value.related_or_exempt_func_income_amt,
        'unrelated_business_revenue_amt': value.unrelated_business_revenue_amt,
        'exclusion_amt': value.exclusion_amt,
    };
}

